import { oAuthClientId, oAuthClientSecret } from '@/data/appConfig'
import { logger, request } from '@/sdk/oauth'
import store from '@/store'

let tokenRequestPromise: Promise<any>

export default function refreshUserToken() {
  if (tokenRequestPromise) {
    return tokenRequestPromise
  }

  const userRefreshToken = store.getters['auth/userRefreshToken']()

  if (!userRefreshToken || userRefreshToken === '') {
    return Promise.resolve(false)
  }

  /** @type {string} a url-encoded string of parameters for the request */
  const requestPayload = [
    `client_id=${oAuthClientId}`,
    `client_secret=${oAuthClientSecret}`,
    `refresh_token=${userRefreshToken}`,
    'grant_type=refresh_token',
  ].join('&')

  tokenRequestPromise = request
    .post('auth/token', requestPayload, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    })
    .then(response => {
      logger(
        'refreshUserToken -> Promise succeeded, saving token %O',
        response.data,
      )
      store.commit('auth/setUserToken', response.data)
      return Promise.resolve(response.data)
    })
    .catch(error => {
      logger('refreshUserToken -> Promise failed -> %O', error)
      store.commit('auth/deleteAuth')
      return Promise.reject(error)
    })
    .finally(() => {
      tokenRequestPromise = null
    })

  return tokenRequestPromise
}
